var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRowsAndColumnsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.90039H12.5C11.9477 9.90039 11.5 10.3481 11.5 10.9004C11.5 11.4527 11.9477 11.9004 12.5 11.9004H18.5C19.0523 11.9004 19.5 11.4527 19.5 10.9004C19.5 10.3481 19.0523 9.90039 18.5 9.90039Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.90039V13.9004C16.5 14.1656 16.3946 14.42 16.2071 14.6075C16.0196 14.795 15.7652 14.9004 15.5 14.9004C15.2348 14.9004 14.9804 14.795 14.7929 14.6075C14.6054 14.42 14.5 14.1656 14.5 13.9004V7.90039C14.5 7.63517 14.6054 7.38082 14.7929 7.19328C14.9804 7.00575 15.2348 6.90039 15.5 6.90039C15.7652 6.90039 16.0196 7.00575 16.2071 7.19328C16.3946 7.38082 16.5 7.63517 16.5 7.90039V7.90039Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.105 11.4997H1.9998C1.17281 11.4997 0.5 10.8269 0.5 9.9999V1.9998C0.5 1.17281 1.17281 0.5 1.9998 0.5H18C18.827 0.5 19.4998 1.17281 19.4998 1.9998V8.94011C19.1386 8.69889 18.7051 8.5612 18.2421 8.5612H17.861V7.1874C17.861 6.24136 16.8685 5.5003 15.6015 5.5003C14.335 5.5003 13.3429 6.24136 13.3429 7.1874V8.5612H12.2571C11.0127 8.5612 10.0003 9.574 10.0003 10.8189C10.0003 11.0522 10.0361 11.2815 10.105 11.4997Z",
    fill: "#272C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50619 10.9997C9.50227 10.9397 9.5003 10.8794 9.5003 10.8189C9.5003 9.2983 10.737 8.0612 12.2571 8.0612H12.8429V7.1874C12.8429 5.96099 14.0546 5.0003 15.6015 5.0003C17.1489 5.0003 18.361 5.96099 18.361 7.1874V8.06369C18.5811 8.07292 18.7951 8.10766 18.9998 8.1654V1.9998C18.9998 1.44851 18.5513 1 18 1H1.9998C1.44851 1 1 1.44851 1 1.9998V9.9999C1 10.5512 1.44851 10.9997 1.9998 10.9997H9.50619ZM10.9556 11.9997H1.9998C0.89711 11.9997 0 11.1026 0 9.9999V1.9998C0 0.89711 0.89711 0 1.9998 0H18C19.1027 0 19.9998 0.89711 19.9998 1.9998V9.9999C19.9998 10.1424 19.9847 10.2847 19.955 10.4228C19.7702 9.62112 19.0667 9.0612 18.2421 9.0612H17.361V7.1874C17.361 6.53283 16.5717 6.0003 15.6015 6.0003C14.6318 6.0003 13.8429 6.53283 13.8429 7.1874V9.0612H12.2571C11.2884 9.0612 10.5003 9.8497 10.5003 10.8189C10.5003 11.2557 10.6615 11.6745 10.9541 11.998L10.9556 11.9997Z",
    fill: "#272C55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5V6.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9H10.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowsAndColumnsOperationIcon);
export default __webpack_public_path__ + "static/media/AddRowsAndColumnsOperationIcon.e40264e94454be8aba0b19c0670cba15.svg";
export { ForwardRef as ReactComponent };